import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "17",
  height: "19",
  viewBox: "0 0 17 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M11.8333 4.33333V3.66667C11.8333 2.73325 11.8333 2.26654 11.6517 1.91002C11.4919 1.59641 11.2369 1.34144 10.9233 1.18166C10.5668 1 10.1001 1 9.16667 1H7.83333C6.89991 1 6.4332 1 6.07668 1.18166C5.76308 1.34144 5.50811 1.59641 5.34832 1.91002C5.16667 2.26654 5.16667 2.73325 5.16667 3.66667V4.33333M6.83333 8.91667V13.0833M10.1667 8.91667V13.0833M1 4.33333H16M14.3333 4.33333V13.6667C14.3333 15.0668 14.3333 15.7669 14.0608 16.3016C13.8212 16.772 13.4387 17.1545 12.9683 17.3942C12.4335 17.6667 11.7335 17.6667 10.3333 17.6667H6.66667C5.26654 17.6667 4.56647 17.6667 4.03169 17.3942C3.56129 17.1545 3.17883 16.772 2.93915 16.3016C2.66667 15.7669 2.66667 15.0668 2.66667 13.6667V4.33333",
      stroke: "#1C1D1F",
      "stroke-width": "1.66667",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }